import { render, staticRenderFns } from "./ocr.vue?vue&type=template&id=184b0984&"
import script from "./ocr.vue?vue&type=script&lang=js&"
export * from "./ocr.vue?vue&type=script&lang=js&"
import style0 from "./ocr.vue?vue&type=style&index=0&id=184b0984&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports